import PropTypes from "prop-types";

/**
 * PropTypes for SearchWrapper component
 *
 * @property {boolean} [isOpen] - Whether search modal is open
 * @property {function} [onClose] - Close handler callback
 */
export const searchWrapperPropTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};
